import React from 'react'
import { NavLink , useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '@material/web/button/text-button';
import { ThemeContext } from '../../theme/DarkMode';

export const MenuItem = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { theme } = React.useContext(ThemeContext);

    const content = [
        { id: 1, title: t('navbar.why-Ahli'), hrefId: '#intro' },
        { id: 2, title: t('navbar.know-us'), hrefId: '#choseus' },
        { id: 3, title: t('navbar.Advantages'), hrefId: '#features' },
    ]

    const backToHome = ()=>{
        navigate('/')
    }
    return (
        <ul>
            {content.map(item => (
                <a onClick={backToHome} href={item.hrefId} key={item.id} className={theme === 'light' ? 'light-menu-list' : 'menu-list'} rel="nofollow">
                    <md-text-button>{item.title}</md-text-button>
                </a>
            ))}
            <NavLink to='/privacy' className={theme === 'light' ? 'light-menu-list' : 'menu-list'}><md-text-button>{t('navbar.privacy')}</md-text-button></NavLink>
            <NavLink to='/guide' className={theme === 'light' ? 'light-menu-list' : 'menu-list'}><md-text-button>{t('navbar.Guide')}</md-text-button></NavLink>
        </ul>
    )
}
